import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { PageHeader, Loader, EmptyState, StatusBadge, fmtDate } from "@/components/shared";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ClipboardCheck, ArrowRight } from "lucide-react";

export default function ValidationQueue() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/validation/queue").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items) return <Loader label="Loading validation queue" />;

  return (
    <div>
      <PageHeader
        overline="Independent validation"
        title="Validation Queue"
        description="Submissions awaiting review. Open one to add per-question and overall validation comments."
      />
      {items.length === 0 ? (
        <EmptyState icon={ClipboardCheck} title="Queue is clear" description="No submissions are currently awaiting validation." />
      ) : (
        <div className="bg-card border border-border rounded-md overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/50">
                <TableHead className="text-xs uppercase tracking-wider">Partner</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">Assessment</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">Version</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">Overall</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">Status</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">Submitted</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.map((v, i) => (
                <motion.tr key={v.submission_id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: i * 0.03 }}
                  className="border-b border-border/60 hover:bg-muted/40 transition-colors cursor-pointer"
                  onClick={() => navigate(`/validation/${v.submission_id}`)} data-testid={`queue-row-${v.submission_id}`}>
                  <TableCell className="py-3 text-sm font-medium">{v.tac_org || v.tac_name}</TableCell>
                  <TableCell className="py-3 text-sm">{v.title}</TableCell>
                  <TableCell className="py-3 font-mono text-sm">v{v.version}</TableCell>
                  <TableCell className="py-3 font-heading font-bold">{v.overall}</TableCell>
                  <TableCell className="py-3"><StatusBadge status={v.status} /></TableCell>
                  <TableCell className="py-3 text-sm text-muted-foreground font-mono">{fmtDate(v.submitted_at)}</TableCell>
                  <TableCell className="py-3 text-right pr-4"><ArrowRight className="h-4 w-4 text-muted-foreground inline" aria-hidden="true" /></TableCell>
                </motion.tr>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
